import { ColumnExtended } from './ColumnExtended';
import { CheckmarkCircleFilled, ErrorCircleFilled, ArrowSyncFilled, WarningFilled, ProhibitedFilled, StackFilled, SendFilled } from '@fluentui/react-icons';


const DASHBOARD_MIN_COLUMN_WIDTH = 60;

export const DashboardColumns: ColumnExtended[] = [
    {
        key: 'documentNumber',
        name: 'Document Number',
        fieldName: 'documentId',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH * 1.5,
    },
    {
        key: 'documentType',
        name: 'Document Type',
        fieldName: 'documentType',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH * 1.2,
    },
    {
        key: 'country',
        name: 'Country',
        fieldName: 'countryCode',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH,
    },
    {
        key: 'company',
        name: 'Company Code',
        fieldName: 'companyCode',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH,
    },
    {
        key: 'partner',
        name: 'Calling Service',
        fieldName: 'eInvPartnerId',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH * 1.5
    },
    {
        key: 'receivedTime',
        name: 'Received Time',
        fieldName: 'startEventTime',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH * 1.5,
        isSorted: true,
        isSortedDescending: true,
        isSortable: true

    },
    {
        key: 'completedTime',
        name: 'Completed Time',
        fieldName: 'endEventTime',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH * 1.5,
        isSortable: true
    },
    {
        key: 'status',
        name: 'Status',
        fieldName: 'status',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH * 1.8,
    onRender: (item) => {
            if (item.status === 'Failed')
                return <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem', color: '#A80000' }}><ErrorCircleFilled aria-hidden="true" /> Failed</span>;
            else if (item.status === 'Succeeded')
                return <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem', color: '#0B6A0B' }}><CheckmarkCircleFilled aria-hidden="true" /> Succeeded</span>;
            else if (item.status === 'In Progress')
                return <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem', color: '#004578' }}><ArrowSyncFilled aria-hidden="true" /> In Progress</span>;
            else if (item.status === 'Warning')
                return <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem', color: '#6B5300' }}><WarningFilled aria-hidden="true" /> Warning</span>;
            else if (item.status === 'Cancel Succeeded')
                return <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem', color: '#0B6A0B' }}><ProhibitedFilled aria-hidden="true" /> Cancel Succeeded</span>;
            else if (item.status === 'Cancel Failed')
                return <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem', color: '#A80000' }}><ProhibitedFilled aria-hidden="true" /> Cancel Failed</span>;
            else if (item.status === 'Cancel In Progress')
                return <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem', color: '#004578' }}><ProhibitedFilled aria-hidden="true" /> Cancel In Progress</span>;
            else if (item.status === 'Batched')
                return <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem', color: '#986F0B' }}><StackFilled aria-hidden="true" /> Batched</span>;
            else if (item.status === 'Sent')
                return <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem', color: '#4b65e1' }}><SendFilled aria-hidden="true" /> Sent</span>;
            return null;
        }
    },
    {
        key: 'extReceiptId',
        name: 'Ext. Receipt Id',
        fieldName: 'extReceiptId',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH * 2.5,
    },
    {
        key: 'internalInvoiceNumber',
        name: 'Internal Invoice Number',
        fieldName: 'invoiceNumber',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH * 1.5,
    },
    {
        key: 'supplier',
        name: 'Supplier',
        fieldName: 'supplier',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH,
    },
    {
        key: 'scenario',
        name: 'Scenario',
        fieldName: 'scenario',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH
    },
    {
        key: 'channel',
        name: 'Channel',
        fieldName: 'channel',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH
    },
    {
        key: 'salesMotion',
        name: 'Sales Motion',
        fieldName: 'salesMotion',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH
    },
    {
        key: 'documentGenerationDate',
        name: 'DocumentGenerationDate',
        fieldName: 'documentGenerationDate',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH * 1.5
    },
    {
        key: 'errorCode',
        name: 'Error Code',
        fieldName: 'errorCode',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH,
    },
    {
        key: 'paymentType',
        name: 'Payment Type',
        fieldName: 'paymentType',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH,
    },
    {
        key: 'invoiceTotal',
        name: 'Amount',
        fieldName: 'invoiceAmount',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH * 2,
        onRender: (item) => {
            if (item.invoiceAmount != null && item.invoiceAmount !== '' && item.invoiceCurrency) {
                return `${item.invoiceAmount} ${item.invoiceCurrency}`;
            }
            return item.invoiceAmount ?? '';
        }
    },
    {
        key: 'mode',
        name: 'Mode',
        fieldName: 'mode',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH
    },
    {
        key: 'numberOfSubmissions',
        name: 'Number of Submissions',
        fieldName: 'numberOfSubmissions',
        isResizable: true,
        minWidth: DASHBOARD_MIN_COLUMN_WIDTH
    }
]
